export default __webpack_public_path__ + "static/media/leaderboard-screenshot.6b38a1ee.png";